<template>
    <b-media vertical-align="center">
        <template #aside>
            <b-avatar
              size="32"
              :src="data.avatar"
              :text="avatarText(data.name)"
              variant="light-primary"
              :to="{ name: 'railway_structure-bridge-view', params: { id: data.id } }"
            />
        </template>
        <b-link
            :to="{ name: 'railway_structure-bridge-view', params: { id: data.id } }"
            class="font-weight-bold d-block text-nowrap"
        >
            {{ data.name }}
        </b-link>
      <small class="text-muted">{{ data.number }}</small>
    </b-media>
</template>

<script>

    import {BLink, BMedia, BAvatar} from 'bootstrap-vue'
    import { avatarText } from '@core/utils/filter'

    export default {

        components: {
            BLink, BMedia, BAvatar
        },

        props: {
            data: {
                type: Object,
                required: true
            }
        },

        setup() {
            return {
               avatarText
            }
        }

    }

</script>
